const StaticFormLabel = ({ title }) => {
  return (
    <div className="manual-form-box mt-30">
        <div className="manual-form-input">
            <div className="title">{title}:</div>
            <div className="underline"></div>
        </div>
    </div>
  );
};

export default StaticFormLabel;